import { render, staticRenderFns } from "./PedidosEmAberto.vue?vue&type=template&id=38a37e1c&scoped=true"
import script from "./PedidosEmAberto.vue?vue&type=script&lang=js"
export * from "./PedidosEmAberto.vue?vue&type=script&lang=js"
import style0 from "./PedidosEmAberto.vue?vue&type=style&index=0&id=38a37e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a37e1c",
  null
  
)

export default component.exports